import styled from 'styled-components'

export const ScrollMoreIndicator = styled.div`
  height: 100%;
  width: ${({ size }: { size: string }) => size || '2px'};
  box-shadow: 0 -0.5rem ${({ shadow }) => shadow || '1rem'} ${({ color }) => color || '#999;'};
  background-color: #fff;
  position: absolute;
  top: 0;
  ${({ isAlignRight, size }: { isAlignRight?: boolean; size: string }) =>
    isAlignRight
      ? `
    right: -${size || '2px'};
  `
      : `
    left: -${size || '2px'};
  `}
`
